import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ControlledProductForm from '../../../components/forms/ControlledProductForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import GetAction from '../../../actions/controlledProducts/GetAction'
import PutAction from '../../../actions/controlledProducts/PutAction'
import ListUsersAction from '../../../actions/users/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class EditControlledProductPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.get(this.props.controlId, this.props.productId)
    this.props.fetchUsers()
  }

  componentDidUpdate(prevProps, prevState) {
    // If fetch is error, close with error
    if (
      prevProps.isLoading
      &&
      !this.props.isLoading
      &&
      this.props.loadError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.FAILURE, "Impossible d'obtenir les infos sur ce matériel.")
      this.props.onClose(false)
    }

    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Matériel modifié.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.put(
      data,
      this.props.controlId,
      this.props.productId
    )
  }

  render() {
    return (
      <Popup
        header='Modifier un matériel à contrôler'
        body={
          <ControlledProductForm
            data={this.props.data}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={this.props.isLoading}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
            productsList={null}
            productsIsFetching={false}
            usersList={this.props.usersList}
            usersIsFetching={this.props.usersIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Modifier',
            color: 'orange',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isLoading={this.props.isLoading}
        isSaving={this.props.isSaving}
      />
    )
  }
}

EditControlledProductPopup.propTypes = {
  // Properties
  controlId: PropTypes.number.isRequired,
  productId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  data: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  loadError: PropTypes.object,
  isSaving: PropTypes.bool.isRequired,
  saveError: PropTypes.object,
  usersList: PropTypes.array,
  usersIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  get: PropTypes.func.isRequired,
  put: PropTypes.func.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    data: state.entities.controls.product.get.data,
    isLoading: state.entities.controls.product.get.isFetching,
    loadError: state.entities.controls.product.get.error,
    isSaving: state.entities.controls.product.put.isFetching,
    saveError: state.entities.controls.product.put.error,
    usersList: state.entities.users.list.data,
    usersIsFetching: state.entities.users.list.isFetching
  }),
  (dispatch) => ({
    get: (id, product_id) => (dispatch(GetAction({ id, product_id }))),
    put: (data, id, product_id) => (dispatch(PutAction({ data, id, product_id }))),
    fetchUsers: () => (dispatch(ListUsersAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.CONTROLS.PUT)))
  })
)(EditControlledProductPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/controlledProducts/EditControlledProductPopup.js